import { Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import FileWithContext from '../../../models/file_with_context'
import { darkGrey } from '../../../pages/ExtranetTickets/utils'
import UpsertFileButton from '../../file_upload'

const DevisInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setRefresh,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <>
      <UpsertFileButton
        labelButton={translate(label, { _: label })}
        height="100px"
        copro_id={record?.copro_id}
        provider={record?.provider_id}
        resource="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        limitQuantity={1}
        validTypes={[FileWithContext.TYPE.QUOTE]}
        validCategories={[FileWithContext.CATEGORY.ADMINISTRATIVE]}
        linkable_id={record.ticket_id}
        linkable_type="tickets"
        upload_by={record.token_id_internal}
        upload_by_type="prestataires"
        expectProvider={true}
        defaultValue={record.fwc.quotes ? record.fwc.quotes : []}
        readOnly={record.fwc.quotes.length >= 1}
        saveResult={({ accepted_files }) => {
          if (accepted_files) {
            const [{ url }] = accepted_files
            setPayload({ ...payload, [source]: url })
            setRefresh(() => {
              return new Date().getTime()
            })
          }
        }}
      />
    </>
  )
}
export default DevisInput
